const CSV_HEADERS = [
  "email", "position", "effective_position", "referrals_count",
  "referred_by", "business_idea", "invited", "source", "created_at",
];

/** Trigger a client-side CSV download of the given waitlist rows. */
export function downloadWaitlistCsv(rows) {
  const lines = [CSV_HEADERS.join(",")];
  for (const row of rows) {
    lines.push(
      CSV_HEADERS.map((h) => `"${String(row[h] ?? "").replace(/"/g, '""')}"`).join(",")
    );
  }
  const blob = new Blob([lines.join("\n")], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `solocrew-waitlist-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

/** Case-insensitive filter across email + business_idea. */
export function filterWaitlist(rows, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return rows;
  return rows.filter(
    (r) =>
      r.email.toLowerCase().includes(q) ||
      (r.business_idea || "").toLowerCase().includes(q)
  );
}
